<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'HOME_PAGE.TITLE' | translate }}
    </glxy-page-title>
    <glxy-page-actions>
      <button data-action="invite-team-member-btn" mat-stroked-button (click)="manageTeamMembers()">
        <mat-icon>people</mat-icon>
        {{ 'OVERVIEW.TOOLBAR_ACTIONS.MANAGE_YOUR_TEAM' | translate }}
      </button>
      <button
        *ngIf="((showChecklist$ | async) === false || checkListDismissed()) && (isMobile$ | async) === false"
        mat-flat-button
        color="primary"
        class="chameleon-checklist-btn"
        data-chmln="chameleon-checklist-btn"
        (click)="trackEvent('chameleon-checklist-btn')"
      >
        <mat-icon>assignment_turned_in</mat-icon>
        {{ 'OVERVIEW.TOOLBAR_ACTIONS.GET_STARTED' | translate }}
      </button>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper [widthPreset]="'wide'">
    <ng-container *ngTemplateOutlet="mainDashboard"></ng-container>
  </glxy-page-wrapper>
</glxy-page>

<ng-template #mainDashboard>
  <!-- Start trial banner-->
  <app-start-trial-banner></app-start-trial-banner>

  <ng-container
    *ngIf="
      (trialExists$ | async) &&
        ((trialExpiringSoon$ | async) || (trialExpired$ | async)) &&
        (staleBanner$ | async) === false &&
        isFree$ | async
    "
  >
    <!-- Trial Has Expired Message -->
    <app-trial-ended-banner *ngIf="trialExpired$ | async"></app-trial-ended-banner>

    <!-- Trial Expiring Soon Message -->
    <ng-container *ngIf="(trialExpired$ | async) === false">
      <glxy-alert
        class="bottom-spacing"
        type="warning"
        [showAction]="true"
        actionTitle="{{ 'HOME_PAGE.TRIAL.UPGRADE_CTA' | translate }}"
        (actionClick)="upgradeSubscription()"
        [showClose]="false"
        (close)="hideBanner()"
      >
        <strong>
          {{ 'HOME_PAGE.TRIAL.EXPIRES_IN' | translate }}
          {{ trialDaysRemaining$ | async }}
        </strong>
        &mdash; {{ 'HOME_PAGE.TRIAL.UPGRADE_EXPLANATION' | translate }}
      </glxy-alert>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="partnerSuspended$ | async">
    <glxy-alert type="error" [solidColor]="true" style="margin: 24px auto; max-width: 720px">
      <strong style="font-size: 16px; line-height: 1.5">
        {{ 'HOME_PAGE.ACCOUNT_SUSPENDED.YOUR_ACCOUNT_IS_SUSPENDED' | translate }}
      </strong>
      <p>
        {{ 'HOME_PAGE.ACCOUNT_SUSPENDED.PAYMENT_OVERDUE' | translate }}
      </p>
      <p>
        {{ 'HOME_PAGE.ACCOUNT_SUSPENDED.HOW_TO_REGAIN_ACCESS' | translate }}
      </p>
      <button mat-stroked-button (click)="mailBilling()">
        {{ 'HOME_PAGE.ACCOUNT_SUSPENDED.CONTACT_BILLING' | translate }}
      </button>
    </glxy-alert>
  </ng-container>

  @if (showCardSection$ | async) {
    <div class="row row-gutters">
      <div class="col col-xs-12 col-lg-8">
        @if (showPartnerLeadMetrics$ | async) {
          <app-lead-metrics class="lead-metrics"></app-lead-metrics>
        }

        @if (showCards$ | async) {
          <ng-container *ngIf="highlights$ | async as highlights">
            <app-highlights
              *ngIf="highlights?.length > 0"
              class="bottom-spacing"
              [highlights]="highlights"
            ></app-highlights>
          </ng-container>

          <ng-container *ngFor="let card of cardConfig$ | async">
            <ng-container *ngIf="card.show">
              <ng-container [ngSwitch]="card.id">
                <ng-container *ngIf="!checkListDismissed()">
                  <app-dashboard-setup-checklist
                    (chcklistVisible)="dismissChecklist()"
                    *ngSwitchCase="'checklist'"
                    class="bottom-spacing"
                  >
                  </app-dashboard-setup-checklist>
                </ng-container>
                <ng-container *ngIf="(showChecklist$ | async) === false || checkListDismissed()">
                  <app-business-account
                    *ngSwitchCase="'addBusinessesAccounts'"
                    class="bottom-spacing"
                  ></app-business-account>
                  <app-snapshot-report-component
                    *ngSwitchCase="'createSnapshotReports'"
                    class="bottom-spacing"
                  ></app-snapshot-report-component>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        }
      </div>

      <div class="col col-xs-12 col-sm-12 col-lg-4">
        <div class="row row-gutters">
          <div
            *ngIf="(showChecklist$ | async) === false || checkListDismissed()"
            class="conquer-local-card-container col col-xs-12 col-sm-6 col-lg-12"
          >
            <va-card class="bottom-spacing">
              <app-announcement-banner-component [newVersion]="true"></app-announcement-banner-component>
            </va-card>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <ng-container *ngIf="highlights$ | async as highlights">
      <app-highlights *ngIf="highlights?.length > 0" class="bottom-spacing" [highlights]="highlights"></app-highlights>
    </ng-container>

    <div class="row row-gutters">
      <div class="col col-xs-12 col-sm-12 col-md-4">
        <div class="row row-gutters">
          <div class="col col-xs-12 col-sm-6 col-md-12">
            <va-card class="announcement-banner-container">
              <app-announcement-banner-component [newVersion]="true"></app-announcement-banner-component>
            </va-card>
          </div>
        </div>
      </div>
    </div>
  }
</ng-template>
